import { api } from '$app/api';

export const getSitewidePromo = (segment) =>
  api.get('/campaigns/sitewide', { params: { segment } }).then((res) => res.data);
